import React from "react";
import ContentLoader from "react-content-loader";

function DetailLoading() {
  return (
    <ContentLoader
      speed={2} // 속도
      // width={530}
      // height={180}
      viewBox="0 0 500 270"
      backgroundColor="#27292d" // 배경색
      foregroundColor="#4b4b4b" // 요소 색
    >
      <circle cx="25" cy="20" r="13" />
      <rect x="42" y="9" rx="3" ry="3" width="88" height="10" />
      <rect x="42" y="22" rx="3" ry="3" width="52" height="10" />

      <rect x="15" y="45" rx="2" ry="2" width="470" height="150" />
      <rect x="15" y="210" rx="2" ry="2" width="470" height="40" />
    </ContentLoader>
  );
}

export default DetailLoading;
